module.exports = __webpack_public_path__ + "static/img/2-10.37fd40d.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-10.png
// module id = 227
// module chunks = 0